import { Badge } from '@ria-client/tw-shared-ui';
import { BadgeCheck } from 'lucide-react';
import type { ProductCardProps } from '../product-card';
import { DriversSection } from './drivers-section';
import { NerdwalletTake } from './nerdwallet-take';
import { ProductSection } from './product-section';

export function ProductCardRedesign({
  cta,
  ctaAnalytics,
  displayName,
  image,
  isSeoBankingFFActive,
  starRating,
  starRatingTooltip,
  reviewLink,
  federallyInsuredAnnotation,
  drivers,
  cardBadgeText,
  bottomLine,
  structuredContentTagline,
}: ProductCardProps) {
  const accordionContent = bottomLine || structuredContentTagline;

  return (
    <div className="rounded-[8px] border border-border" data-testid="product-card-redesign">
      <div className="flex flex-col gap-3 px-3 pb-0 pt-3 md:px-3.5 md:pt-3.5">
        <Badge className="mb-1 max-w-fit md:mb-2" icon={BadgeCheck} text={cardBadgeText} />
        <div className={cardBadgeText ? '' : 'mt-2'}>
          <ProductSection
            cta={cta}
            ctaAnalytics={ctaAnalytics}
            displayName={displayName}
            federallyInsuredAnnotation={federallyInsuredAnnotation}
            image={image}
            reviewLink={reviewLink}
            starRating={starRating}
            starRatingTooltip={starRatingTooltip}
          />
        </div>
        <DriversSection drivers={drivers} />
      </div>
      {accordionContent && (
        <div className="border-t border-border">
          <NerdwalletTake
            content={accordionContent}
            isDefaultExpanded={isSeoBankingFFActive}
            offerId={ctaAnalytics.offerId}
            reviewLink={reviewLink}
          />
        </div>
      )}
    </div>
  );
}
